// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3pGT8","productName":"Table_productName__2r--1"};